import { uid } from './constants.js';
import { validateWallLengthLocks, assertWallLengthLockTransition, WALL_LENGTH_LOCK_TOLERANCE } from './wallLengthLocks.js';

const levels=doc=>[{id:doc.activeFloorId||'ground',plan:doc},...(doc.floors||[]).map(f=>({id:f.id,plan:f.plan}))];
/** Undo/Redo is an explicit change of lock intent, retaining irreversible release history. */
export function reconcileWallLocksForHistory(current,target,reason) {
  validateWallLengthLocks(current);validateWallLengthLocks(target);
  const doc=structuredClone(target), destinations=levels(doc), currentLevels=levels(current);
  const desired=destinations.flatMap(f=>(f.plan.wallLengthLocks||[]).filter(l=>l.state==='active').map(lock=>({...f,lock})));
  const records=currentLevels.flatMap(f=>(f.plan.wallLengthLocks||[]).map(lock=>({...f,lock})));
  // With no records, preserve the legacy document shape and ordinary history behavior.
  if(!records.length&&!desired.length)return doc;
  for(const f of destinations)f.plan.wallLengthLocks=[];
  const fulfilled=new Set();
  for(const {id:floorID,lock:original} of records){
    const lock=structuredClone(original);
    const matches=desired.filter(d=>d.lock.wallId===lock.wallId&&Math.abs(d.lock.metres-lock.metres)<=WALL_LENGTH_LOCK_TOLERANCE);
    const wanted=matches.find(d=>d.lock.id===lock.id)||matches.find(d=>d.id===floorID)||(matches.length===1?matches[0]:null);
    let destination=destinations.find(f=>f.id===floorID)||destinations[0];
    if(lock.state==='active'){
      if(wanted){destination=wanted;fulfilled.add(wanted.lock.id);}
      else {lock.state='released';lock.releasedAt=new Date(Math.max(Date.now(),Date.parse(lock.createdAt))).toISOString();lock.releaseReason=reason+' wall length lock change';}
    }
    destination.plan.wallLengthLocks.push(lock);
  }
  for(const wanted of desired){
    if(fulfilled.has(wanted.lock.id))continue;
    // Released identities remain immutable; re-locking is a fresh review action.
    const lock={...structuredClone(wanted.lock),id:uid('length-lock-'),createdAt:new Date().toISOString()};
    wanted.plan.wallLengthLocks.push(lock);
  }
  assertWallLengthLockTransition(current,doc);return doc;
}
